import axios from 'axios'

export default {
  currentUser() {
    return axios.get('/api/users/current')
  },
  signIn(formData) {
    return axios.post('/api/auth/login', formData)
  },
  devLogin(userId) {
    return axios.post('/api/auth/login-dev', null, { params: { userId } })
  },
  signOut() {
    return axios.get('/api/auth/logout')
  }
}
